import { RMSvgIconProps } from 'components/customComponents/CommonComponents/RMSvgIcon';

export const actionButtonBaseProps: Omit<RMSvgIconProps, 'name'> = {
  width: '1rem',
  height: '1rem',
  fill: 'white',
};

export const actionButtonStyle = {
  backgroundColor: '#4CAF50',
  width: '1.75rem',
  height: '1.75rem',
};

export enum ProtectantAgentType {
  Cryoprotectant,
  Soaking,
}

export const ProtectantAgentTitle = {
  [ProtectantAgentType.Cryoprotectant]: 'Cryoprotectant',
  [ProtectantAgentType.Soaking]: 'Soaking',
};
